export const AIRLINES_LIST_PAGE_URLS: {[key: string]: string } = {
    'it': '/it/voli/compagnie-aeree',
    'en': '/en/flights/airlines'
};
